import React, { ErrorInfo, ReactNode } from 'react';
import * as Sentry from '@sentry/browser';

export class ErrorBoundary extends React.Component<{ children?: ReactNode }, object> {
    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState(null);
        Sentry.withScope((scope) => {
            scope.setExtra('componentStack', errorInfo.componentStack);
            Sentry.captureException(error);
        });
    }

    render() {
        return this.props.children;
    }
}
